<div class="grid mt-2 ml-3 overview-details mr-0">
    <div class="col-6 md:col-12 lg:col-6 pl-0">

        <div class="card p-fluid overview-screen">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase details-btn" translate>change_review.lbl_overview_details</label>
                </div>
                <div class="edit justify-content-center mb-3 cursor-pointer change-btn" (click)="redirectToEdit()">
                    <label class="card-action pr-2 cursor-pointer" translate>change_review.lbl_view_change</label>
                    <i class="eye-icon pi pi-eye cursor-pointer"></i>
                </div>
            </div>
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabel('change_review.lbl_status')}}</label>
                </div>
                <div class="col-8  status-background">
                <label class="detail-value p-1" [ngStyle]="{
                      'background-color': 
                        attributeValues?.status === 'Pending' ? '#ffa50026' :
                        attributeValues?.status === 'Approved' ? '#32cd3226' :
                        attributeValues?.status === 'Rejected' ? '#ff370026' : 'transparent'
                    }">{{ attributeValues?.status || '--' }}</label>
                </div>
            </div>
            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabel('change_review.lbl_list_id')}}</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues?.protocolReviewRequestId || '--'  }}</label>
                </div>
            </div>
            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabel('change_review.lbl_created_by')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues?.createdByName || '--'   }}</label>
                    
                </div>
            </div>
            <hr class="hr-line">


            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabel('change_review.lbl_model')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues?.model || '--'  }}</label>
                    
                </div>
            </div>
            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabel('change_review.lbl_action')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues?.action || '--'  }}</label>
                    
                </div>
            </div>
            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabel('change_review.lbl_protocol')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues?.protocolName || '--'  }}</label>
                    
                </div>
            </div>
            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabel('change_review.lbl_data')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues?.data || '--'  }}</label>
                    
                </div>
            </div>
            
            <hr class="hr-line"> 
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabel('change_review.lbl_action_reason')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues?.reviewerComment || '--' }}</label>
                    
                </div>
            </div>

            <hr class="hr-line"> 
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabel('change_review.lbl_created_at')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues?.createdAt ? metaDataService.formatDateTimeOnTZ(attributeValues.createdAt, 'D-MMMM-YYYY h:mm A') : '--' }}</label>
                    
                </div>
            </div>
        </div>


    </div>

</div>

